import { initializeApp, getApps } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Firebase config
// const firebaseConfig = {
//   apiKey: "AIzaSyDlOAccQPH1Q2qNeKhjz3GLlj46rZIqcag",
//   authDomain: "rally-bulls-39fbf.firebaseapp.com",
//   projectId: "rally-bulls-39fbf",
//   storageBucket: "rally-bulls-39fbf.appspot.com",
//   messagingSenderId: "469553335993",
//   appId: "1:469553335993:web:9a760e936f4b7808175568",
//   measurementId: "G-TDHEPDWSCW"
// };
// const firebaseConfig = {
//   apiKey: "AIzaSyDlOAccQPH1Q2qNeKhjz3GLlj46rZIqcag",
//   authDomain: "rally-bulls-39fbf.firebaseapp.com",
//   projectId: "rally-bulls-39fbf",
//   storageBucket: "rally-bulls-39fbf.firebasestorage.app",
//   messagingSenderId: "469553335993",
//   appId: "1:469553335993:web:9a760e936f4b7808175568",
//   measurementId: "G-TDHEPDWSCW"
// };

// Firebase config
const firebaseConfig = {
  // apiKey: "AIzaSyDlOAccQPH1Q2qNeKhjz3GLlj46rZIqcag",
  // authDomain: "rally-bulls-39fbf.firebaseapp.com",
  // projectId: "rally-bulls-39fbf",
  // storageBucket: "rally-bulls-39fbf.firebasestorage.app",
  // messagingSenderId: "469553335993",
  // appId: "1:469553335993:web:0bc5e0f4ff853f58175568",
  // measurementId: "G-G5FM9ZJ5DQ"
  apiKey: "AIzaSyDlOAccQPH1Q2qNeKhjz3GLlj46rZIqcag",
  authDomain: "rally-bulls-39fbf.firebaseapp.com",
  projectId: "rally-bulls-39fbf",
  storageBucket: "rally-bulls-39fbf.firebasestorage.app",
  messagingSenderId: "469553335993",
  appId: "1:469553335993:web:9a760e936f4b7808175568",
  measurementId: "G-TDHEPDWSCW",
};
// console.log("app", getApps().length)
// if (!getApps().length) {
//   initializeApp(firebaseConfig);
// }

export const app = initializeApp(firebaseConfig);

export let messaging = null;
if (typeof window !== "undefined" && typeof navigator !== "undefined" && navigator.serviceWorker) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn("Firebase Messaging is not supported or failed to initialize", error);
  }
}
